import api from "./api";
import webPush from "./webPush";

// Encerra a sessao deste aparelho: desliga o aviso e revoga o access token.
//
// A ordem nao pode inverter. O DELETE da inscricao precisa do token valido, e
// depois do revoke ele volta 401 -- a baixa no servidor falharia em silencio.
// Os dois vem antes de limpar o localStorage, de onde o interceptor le o
// `userToken` para montar o header.
//
// O aviso e por aparelho, mas o CONTEUDO e da pessoa: nome da empresa e titulo
// da vaga de quem saiu. Sem desligar aqui, o navegador continua recebendo as
// vagas dela, e quem entrar depois herda uma inscricao que o servidor ainda lhe
// atribui.
//
// Nunca lanca: se a rede falhar, o logout do front segue normalmente.
export async function endTalentSession() {
  try {
    await webPush.unsubscribeCurrentDevice({ reason: 'session_end' });
  } catch (_) {
    // A inscricao do navegador ja foi destruida dentro da funcao mesmo quando a
    // API nao responde. O que pode ficar para tras e a baixa no servidor, e o
    // endpoint orfao o servidor poda no primeiro envio que falhar.
  }

  try {
    await api.get("/api/v1/talent/logout");
  } catch (_) {
    // best-effort: se a revogacao falhar, o logout do front segue mesmo assim.
    // Sem ela, um token que tenha vazado continua valido ate o exp (~1 ano).
  }
}
